import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getWarehouseByEstablishment, getWarehouseItemList, synchronizeWarehouseItems, getWarehouseItemListQuery } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditItemModal from './Add_Edit/AddEditItem';
import DeleteItemModal from './Delete/DeleteItem';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import ReceptionItemModal from './Modals/ReceptionItemModal';
import { useUser } from '../../../Components/Hooks/useUserHooks';

const WarehouseItemsList = ({ establishment_id }) => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const { user } = useUser();

	const selectorItems = createSelector(
		state => state.WarehouseItems,
		data => ({
			dataList: data?.warehouseItemList || [],
			isLoadingList: data?.isLoadingList || false,
			isItemSuccess: data?.isItemSuccess || false,
			error: data?.error || null,
			isAdding: data?.isAdding || false,
			isAdded: data?.isAdded || false,
			isAddError: data?.isAddError || false,
			isUpdating: data?.isUpdating || false,
			isUpdated: data?.isUpdated || false,
			isUpdateError: data?.isUpdateError || false,
			isDeleting: data?.isDeleting || false,
			isDeleted: data?.isDeleted || false,
			isDeleteError: data?.isDeleteError || false,
		})
	);

	const { dataList, isLoadingList } = useSelector(selectorItems);

	const selectorWarehouse = createSelector(
		state => state.Warehouses,
		data => ({
			itemWarehouse: data?.itemWarehouse || null,
			itemWarehouseDetail: data?.itemWarehouseDetail || null,
			isLoadingWarehouseList: data?.isLoadingWarehouseList || false,
		})
	);

	const { itemWarehouse, itemWarehouseDetail, isLoadingWarehouseList } = useSelector(selectorWarehouse);


	useEffect(() => {
		const fetchData = async () => {
			const warehouse = await dispatch(getWarehouseByEstablishment(establishment_id));
			dispatch(getWarehouseItemListQuery({ establishment_id: establishment_id }));
		};
		fetchData();
	}, [establishment_id]);


	const [dataItem, setDataItem] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Item
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	const [modalReception, setModalReception] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	function handleToggleModalReception() {
		setModalReception(!modalReception);
		toggleTab('1');
		// validation.resetForm();
	}

	// Delete Data
	const handleClickDelete = data => {
		setDataItem(data);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = data => {
		setDataItem(data);
		handleToggleModal();
	};

	function synchronize() {
		dispatch(synchronizeWarehouseItems({ warehouse_id: itemWarehouse._id, group_code: '103-104' }));
	}


	useEffect(() => {
		dispatch(getWarehouseItemListQuery({ establishment_id: establishment_id }));
	}, [itemWarehouseDetail]);

	const columns = useMemo(
		() => [
			{ header: 'Codigo SAP', accessorKey: 'code_sap', size: 'auto' },
			{ header: 'Categoría', accessorKey: 'warehouse_category.name', dataType: 'multi-select', size: 'auto' },
			{ header: 'Unidad', accessorKey: 'unit_measurement.name', size: 'auto' },
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{ header: 'Precio USD', accessorKey: 'price', size: 'auto', summary: true, type: 'separator' },
			{ header: 'Cantidad', accessorKey: 'quantity', size: 'auto', summary: true, type: 'separator' },
			{ header: 'Reservado', accessorKey: 'reserved', size: 'auto', summary: true, type: 'separator' },
			{ header: 'Disponible', accessorKey: 'available', size: 'auto', summary: true, type: 'separator' },
		],
		[handleClickEdit]
	);


	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										{['BDG', 'ABS', 'ADM'].includes(user.role_code) && (
											<button className='btn btn-label btn-primary' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
												{isLoadingWarehouseList ? (<i className="label-icon"><Spinner size='sm' /></i>) : <i className="icon-refresh-cw label-icon"></i>} Sincronizar con SAP
											</button>
										)}

										{['BDG', 'ABS', 'ADM'].includes(user.role_code) && (
										<button className='btn btn-label btn-primary' onClick={() => { setIsEdit(false); setDataItem({}); handleToggleModal(); }}>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Agregar Item
										</button>
										)}
										
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getWarehouseItemListQuery}
								queryPopulate={[
									'warehouse',
									'warehouse_category',
									'warehouse_group',
									'unit_measurement',	
								]}
								baseFilters={{
									warehouse: {
										establishment_id:{
											$eq: establishment_id,
										}
									},
								}}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								customToolbarActions={[
									{
										label: 'Sincronizar',
										icon: Icons.refresh,
										className: 'gap-1',
										onClick: () => { synchronize(); },
										title: 'Sincronizar con SAP',
										disabled: isLoadingWarehouseList
									},
									{
										label: 'Agregar',
										icon: Icons.plus,
										onClick: () => { 
											setIsEdit(false); 
											setDataItem({}); 
											handleToggleModal(); 
										},
										title: 'Agreagar Nuevo Item'
									}
								]}
								nameFile={'items'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditItemModal
				dataItem={dataItem}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteItemModal
				dataItem={dataItem}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default WarehouseItemsList;
